<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          递单交接检查
        </div>
        <div style="padding: 10px 25px">
          <el-form :inline="true" :model="form2" class="demo-form-inline">
            <el-form-item label="输入快递单号">
              <el-input
                ref="shipping_num_input"
                v-model="form2.shipping_num"
                placeholder="快递单号"
                autofocus="autofocus"
                @keyup.native.enter="onSubmit"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                ref="shipping_num_button"
                type="primary"
                @click="onSubmit"
                >提交</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </el-col>
    </el-row>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="">
                  <el-input
                    v-model="form.wave_picking_no"
                    placeholder="波次单号"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.shipping_num"
                    placeholder="快递单号"
                  ></el-input>
                </el-form-item>
                <el-select v-model="form.status" placeholder="状态">
                  <el-option
                    v-for="item in statusArr"
                    :key="item.key"
                    :label="item.label"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
                <el-form-item label="创建时间：">
                  <el-date-picker
                    v-model="form.create_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div style="margin-bottom: 0">
          <div
            style="
              background: #f3f3f3;
              height: 50px;
              line-height: 30px;
              padding: 0 25px;
              display: flex;
              align-items: center;
            "
          >
            <div>数据列表：</div>
            <el-button
              style="margin-left: auto"
              type="success"
              size="mini"
              @click="output"
              >导出</el-button
            >
          </div>
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.data"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column
              align="center"
              prop="wave_picking_no"
              label="波次单号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="shipping_company"
              label="快递公司"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="shipping_num"
              label="快递单"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="admin_name"
              label="扫描人"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="create_time"
              label="扫描时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="status_txt"
              label="状态"
            ></el-table-column>
          </el-table>
        </div>

        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper "
            :total="resData.total"
            :page-size="resData.per_page"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      logVisible: false,
      resData: null,
      logData: null,
      form: {
        create_time: [],
        wave_picking_no: "",
        status: "",
        shipping_num: "",
      },
      form2: {
        shipping_num: "",
      },
      statusArr: [],
      loading: false,
      tableLoading: false,
      url: "/erp/WavePicking/wavePickingCheckLogList",
      curPage: 1,
      filterFold: false,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
    filteredForm2() {
      for (const key in this.form2) {
        if (
          this.form2[key] === undefined ||
          this.form2[key] === "" ||
          this.form2[key] === null
        ) {
          delete this.form2[key];
        }
      }
      return this.form2;
    },
  },
  methods: {
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data.list;
          this.form = res.data.data.list;
          this.statusArr = res.data.data.statusArr;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      const multipleSelection = [];
      for (const key in val) {
        multipleSelection[key] = {
          id: val[key].id,
        };
      }
      this.form.multipleSelection = JSON.stringify(multipleSelection);
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data.list;
          // this.form = res.data.data.list;
          this.statusArr = res.data.data.statusArr;
        }
      });
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data.list;
          // this.form = res.data.data.list;
          this.statusArr = res.data.data.statusArr;
        }
      });
    },
    trim(str, is_global) {
      let result;
      result = str.replace(/(^\s+)|(\s+$)/g, "");
      if (is_global.toLowerCase() == "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    },
    onSubmit() {
      // this.$refs.shipping_num_input.$el.children[0].blur();
      const url = "/erp/WavePicking/wavePickingCheckLog";
      this.$http.post(url, this.filteredForm2).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          if (res.data.data == 1) {
            this.$refs.shipping_num_input.$el.children[0].blur();
            this.$refs.shipping_num_button.$el.children[0].blur();
            this.$msgbox(res.data.msg, "提示", {
              confirmButtonText: "确定",
              center: true,
              type: "info",
            }).then(() => {
              this.$refs.shipping_num_input.$el.children[0].focus();
            });
          }
          this.fetchData();
        }
        this.form2.shipping_num = "";
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/wavepicking/WavePickingCheckLogList.vue